import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  selectCompanyAddress,
  selectPrefix,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setreportsFromDate,
  setreportsTodate,
} from "../../../utility/Redux/profile";
import { FromToDate } from "../../../utility/component/fromToDate";
import { GetSaleSummary } from "./func";
import { selectToken } from "../../../utility/Redux/security";
import { SummaryColumns } from "./columns";
import Footer from "./footer";
import { useReactToPrint } from "react-to-print";
import GeniusTableReports from "../../../utility/component/geniusComponents/geniusTableData";
import IsLocalData from "../../../utility/component/isLocalData";
import FromToDateMobile from "../../../utility/component/fromToDateMobile";
import GeniusTableForReports from "../../../utility/component/printReport";
import { Pagination } from "@mui/material";
import { AccountMasterHelp } from "../../../help";
import {
  setAlertWithTitle,
  setSpinnerLoading,
} from "../../../utility/Redux/modal";
import GeniustextInput from "../../../utility/component/mastertext";
import { FormatNumber2 } from "../../../utility/functions/formatNumber";
import {
  ExitButton,
  SaveButton,
  UndoButton,
} from "../../../utility/component/buttons";
import { CallAPIPromise } from "../../../billing/common";
import { useNavigate } from "react-router-dom";

const Account_Reconcillation = () => {
  const prefix = useSelector(selectPrefix);
  const [summaryList, setSummaryList] = useState([]);
  const fromDate = useSelector(selectreportFromDate);
  const ToDate = useSelector(selectreportToDate);
  const width = useSelector(selectWidth);
  const printRef = useRef(null);
  const [filterType, setFilterType] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [accModalStatus, setAccModalStatus] = useState(false);
  const [accountDeails, setAccountDetails] = useState("");
  const [openingBalDetails, setOpeningBalDetails] = useState("");
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const fetchData = (page) => {
    GetSaleSummary(
      {
        table_prefix: prefix,
        FDATE: moment(fromDate).format("YYYY-MM-DD"),
        TDATE: moment(ToDate).format("YYYY-MM-DD"),
        page: page ? page : currentPage,
        ACCOUNT_NO: accountDeails?.ACCOUNT_NO,
        TRANSACTION_TYPE: "",
        ...accountDeails,
      },
      token,
      dispatch,
      setSummaryList,
      setTotalPages,
      setCurrentPage,
      setOpeningBalDetails
    );
  };
  const navigate = useNavigate();
  const okButton = (page) => {
    if (accountDeails) {
      fetchData(page);
    } else {
      dispatch(
        setAlertWithTitle({
          title: "Alert",
          msg: "Select account details first",
        })
      );
    }
  };
  const columns = SummaryColumns(width, openingBalDetails);
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: `
  @page {
    size: portrait;
  }
`,
  });

  useEffect(() => {
    const callback = (details, data) => {
      setSummaryList(data);
      setAccountDetails(details[0]);
      dispatch(setreportsFromDate(details[0].FDATE));
      dispatch(setreportsTodate(details[0].TDATE));
    };
    const elseFunc = () => {};
    IsLocalData("Account_Reconcillation", callback, elseFunc);
  }, []);
  const difrence = summaryList[0]
    ? summaryList.reduce((acc, row) => acc + Number(row.DEBIT), 0) -
      summaryList.reduce((acc, row) => acc + Number(row.CREDIT), 0)
    : 0;
  const company = useSelector(selectCompanyAddress);
  return (
    <div className=" bg-white flex flex-col h-full overflow-y-auto   ">
      <div className=" flex flex-col h-full p-3 ">
        <div className="font-semibold pb-2">Account Ledger</div>

        <div>
          {window.innerWidth <= 700 ? (
            <>
              <FromToDateMobile
                onPrintClick={handlePrint}
                submit={() => {
                  okButton();
                }}
              />
            </>
          ) : (
            <FromToDate
              hideReset={true}
              onPrintClick={handlePrint}
              submit={() => {
                okButton();
              }}
              partyData={{
                NAME: accountDeails?.NAME,
              }}
              onPartyMasterSearchClick={() => {
                setAccModalStatus(true);
              }}
              reset={() => {
                setSummaryList([]);
              }}
            />
          )}
        </div>
        <div
          style={{
            width: columns.reduce((acc, row) => acc + Number(row.width), 0),
          }}
          className="flex justify-between mt-3 mb-2 bg-gray-100 rounded-sm p-2"
        >
          <div className="grid grid-cols-1 ">
            <GeniustextInput
              max={15}
              autofocus={true}
              value={accountDeails?.ACCOUNT_NO}
              title={"Account No."}
              titleAlign={"left"}
              type={"text"}
              titleWidth={130}
              backgroundColor={"transparent"}
              readOnly={true}
              grid={true}
            />
            <GeniustextInput
              max={15}
              autofocus={true}
              value={accountDeails?.NAME}
              title={"Account Name"}
              type={"text"}
              titleWidth={130}
              titleAlign={"left"}
              backgroundColor={"transparent"}
              readOnly={true}
              grid={true}
            />
          </div>
        </div>
        {summaryList[0] ? (
          <div
            style={{
              height: `calc(100% - 180px)`,
              width: "100%",
              marginTop: 10,
            }}
            className=" mb-2  "
          >
            <GeniusTableReports
              data={summaryList.filter((s) => {
                if (filterType) {
                  return filterType === "Credit"
                    ? s.CREDIT > 0
                    : filterType === "Debit"
                    ? s.DEBIT > 0
                    : false;
                } else {
                  return true;
                }
              })}
              columns={columns}
              pagination={
                <div
                  style={{
                    width: columns.reduce(
                      (acc, row) => acc + Number(row.width),
                      0
                    ),
                  }}
                  className="flex justify-end mt-1"
                >
                  {" "}
                  <Pagination
                    onChange={(e, v) => {
                      okButton(v);
                    }}
                    count={totalPages}
                    page={currentPage}
                  />{" "}
                </div>
              }
              footer={<Footer columns={columns} rows={summaryList} />}
            />
          </div>
        ) : (
          <div className="h-full flex justify-center items-center text-sm text-gray-400 border mt-3 rounded-sm">
            No Records Found
          </div>
        )}

        <div className="flex  flex-1 justify-between text-sm mt-2">
          <div className="flex items-center ">
            <div className=" mr-2 font-bold  text-[18px] ">Total Records</div>:
            <div className="ml-1 text-[18px]  text-right font-semibold">
              {summaryList.length}
            </div>
          </div>
          <div className="flex items-center ">
            <SaveButton
              onClick={() => {
                if (summaryList[0]) {
                  dispatch(setSpinnerLoading("Saving"));
                  CallAPIPromise("/api/bankReconcilation/updateVoucherMaster", {
                    table_prefix: prefix,
                    bank_concile_cart: summaryList.map((s) => {
                      return {
                        VOUCHER_NO: s.VOUCHER_NO,
                        SERIAL_NO: s.SERIAL_NO,
                        LEDGER_NAME: s.LEDGER_NAME,
                        FAVOURING_NAME: s.FAVOURING_NAME,
                        CLEARANCE_DATE: s.CLEARANCE_DATE,
                        INSTRUMENT_NUMBER: s.INSTRUMENT_NUMBER,
                        INSTRUMENT_DATE: s.INSTRUMENT_DATE,
                        TYPE_OF_TRANSACTION: s.TYPE_OF_TRANSACTION,
                        BANK_NAME: s.BANK_NAME,
                      };
                    }),
                  })
                    .then(() => {
                      dispatch(
                        setAlertWithTitle({
                          title: "Alert",
                          msg: "Data Saved Successfully",
                        })
                      );
                      fetchData(1);
                    })
                    .finally(() => {
                      dispatch(setSpinnerLoading(false));
                    });
                }
              }}
            />
            <ExitButton
              onClick={() => {
                navigate("/accounts");
              }}
            />
          </div>
        </div>
      </div>
      <AccountMasterHelp
        onRowClick={(p) => {
          setAccModalStatus(false);
          setAccountDetails(p.row);
        }}
        status={accModalStatus}
        onClose={() => {
          setAccModalStatus(false);
        }}
      />
      <VoucherPrint
        printRef={printRef}
        company={company}
        voucherDetails={summaryList}
        fromDate={fromDate}
        ToDate={ToDate}
      />
    </div>
  );
};
const VoucherPrint = ({
  voucherDetails,
  company,
  printRef,
  fromDate,
  ToDate,
}) => {
  return (
    <div
      ref={printRef}
      id="print-component"
      className=" mx-auto my-4 p-2 text-xs font-mono print:block hidden   border border-black"
    >
      {/* Header */}
      <div className="text-center font-bold text-lg mb-2">
        ACCOUNT RECONCILLATION
      </div>

      {/* Company Info */}
      <div className="border border-dotted border-black mb-2">
        <div className="p-2">
          <div className="font-bold">{company.companyName}</div>
          <div>
            {company.address}, {company.city}, {company.state}
          </div>
          <div>
            Mob: {company.mobile} | Email: {company.email}
          </div>
          <div>GSTIN: {company.regdNo}</div>
        </div>
      </div>

      {/* Voucher Info */}
      {voucherDetails[0] && (
        <div className="grid grid-cols-2 border border-dotted border-black mb-2">
          <div className="p-2 border-r border-dotted border-black">
            <div>
              <strong>From Date :</strong>{" "}
              {moment(fromDate).format("DD/MM/YYYY")}
            </div>
            <div>
              <strong>Account No :</strong> {voucherDetails[0].ACCOUNT_NO}
            </div>
            <div>
              <strong>Account Name :</strong> {voucherDetails[0].ACCOUNT_NAME}
            </div>
          </div>
          <div className="p-2">
            <div>
              <strong>To Date:</strong> {moment(ToDate).format("DD/MM/YYYY")}
            </div>{" "}
            <div>
              <strong>Balance Sheet Class :</strong>{" "}
              {voucherDetails[0].BALANCE_SHEET_CLASS}
            </div>
          </div>
        </div>
      )}

      {/* Table Header */}
      <div className="grid grid-cols-[100px,100px,200px,200px,100px,100px,150px] text-center border border-dotted border-black font-bold">
        <div className="border-r border-dotted border-black p-1">Date</div>
        <div className="border-r border-dotted border-black p-1">Voucher</div>
        <div className="border-r border-dotted border-black p-1">Party</div>
        <div className="border-r border-dotted border-black p-1">
          Description
        </div>
        <div className="border-r border-dotted border-black p-1">Debit</div>
        <div className="border-r border-dotted border-black p-1">Credit</div>
        <div className="p-1">Clearance Date</div>
      </div>

      {/* Table Rows */}
      {voucherDetails?.map((v, i) => (
        <div
          key={i}
          className="grid  grid-cols-[100px,100px,200px,200px,100px,100px,150px] text-center border-l border-r border-b border-dotted border-black"
        >
          <div className="border-r border-dotted border-black p-1">
            {moment(v.DATE).format("DD/MM/YYYY")}
          </div>
          <div className="border-r border-dotted border-black p-1 text-left">
            {v.VOUCHER_NO}
          </div>
          <div className="border-r border-dotted border-black p-1 text-left">
            {v.ACCOUNT_NAME}
          </div>
          <div className="border-r border-dotted border-black p-1 text-left">
            {v.NARRATION}
          </div>
          <div className="border-r border-dotted text-right border-black p-1">
            {v.DEBIT > 0 ? FormatNumber2(v.DEBIT) : ""}
          </div>
          <div className="p-1 border-dotted text-right border-r  border-black">
            {v.CREDIT > 0 ? FormatNumber2(v.CREDIT) : ""}
          </div>
          <div className=" p-1">
            {v.CLEARANCE_DATE && moment(v.CLEARANCE_DATE).format("DD/MM/YYYY")}
          </div>
        </div>
      ))}

      {/* Narration */}
      {/* <div className="border-l border-r border-dotted border-black p-2">
        <strong>Narration:</strong> {voucherDetails[0]?.NARRATION || "N/A"}
      </div> */}

      {/* Totals */}
      {/* <div className="grid grid-cols-4 text-center border border-dotted border-black font-bold">
        <div className="col-span-2 border-r border-dotted border-black p-1">
          Total
        </div>
        <div className="border-r border-dotted  text-right border-black p-1">
          {FormatNumber2(
            voucherDetails.reduce((acc, curr) => acc + curr.DEBIT, 0)
          )}
        </div>
        <div className="p-1  text-right">
          {FormatNumber2(
            voucherDetails.reduce((acc, curr) => acc + curr.CREDIT, 0)
          )}
        </div>
      </div> */}

      <div className="grid grid-cols-3 mt-[100px] text-center border border-dotted border-black  text-xs">
        <div className=" border-dotted border-black p-1"></div>
        <div className="border-r border-dotted border-black p-1"></div>
        <div className="p-1">AUTHORIZED BY</div>
      </div>

      <div className="flex justify-between text-xs mt-2">
        <div>
          Powered by: <strong>genius office</strong>
        </div>
      </div>
    </div>
  );
};
export default Account_Reconcillation;
